<template>
  <!-- test -->
  <div :style="minWidth">
    <Table
      :scheme="s"
      :data="d"
      resizable
      :noDataTemplate="noDataTemplate"
      ref="_dynTable"
      checkType="none"
      :fixHeader="fixHeight"
      :loading="loading"
    />
  </div>
</template>
<script>
import {
  Table
  // TableColumn
} from 'kpc/components/table';

export default {
  name: 'dyn-table',
  components: {
    Table
    // TableColumn
  },
  props: {
    fixHeight: {
      type: Number,
      default: 200
    },
    scheme: {
      type: Array,
      default: function() {
        return [];
      }
    },
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    pageSize: {
      type: Number,
      default: 50
    }
  },
  mounted() {
    this.getCurrentData();
    this.$refs._dynTable.scroll.addEventListener('scroll', event => {
      let { scrollTop, scrollHeight, clientHeight } = event.target;
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.currentData.length < this.data.length) {
          this.getCurrentData();
        }
      }
    });
  },
  watch: {
    data() {
      this.currentData = [];
      this.getCurrentData();
    }
  },
  computed: {
    noDataTemplate() {
      // if (this.loading) {
      //   return ''
      // }
      return '/(ㄒoㄒ)/~~ 没有找到亲要的数据哦~';
      // return '';
    },
    minWidth() {
      return {
        'min-width': this.scheme.length * 90 + 'px',
        background: 'yellow'
      };
    },
    s() {
      let r = {};
      for (let i = 0; i < this.scheme.length; i++) {
        let item = this.scheme[i];
        r[item] = item;
      }

      return r;
    },
    d() {
      console.log('makde table data========');
      let r = [];
      for (let i = 0; i < this.currentData.length; i++) {
        let item = this.currentData[i];
        if (Array.isArray(item)) {
          let temp = {};
          for (let j = 0; j < item.length; j++) {
            temp[this.scheme[j]] = item[j];
          }
          r.push(temp);
        }
      }
      return r;
    }
  },
  data() {
    return {
      currentData: [],
      loading: false
      // scheme: {a: '表头1', b: '表头2'},
      // data: [{a: '第一行', b: '哈哈2'}, {a: '第二行', b: '哈哈2'}],
    };
  },
  methods: {
    getCurrentData() {
      this.loading = true;
      let start = this.currentData.length;
      let end = this.currentData.length + this.pageSize;
      this.currentData = this.currentData.concat(this.data.slice(start, end));
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    exportTable(name) {
      let r = [];
      for (let i = 0; i < this.data.length; i++) {
        let item = this.data[i];
        if (Array.isArray(item)) {
          let temp = {};
          for (let j = 0; j < item.length; j++) {
            temp[this.scheme[j]] = item[j];
          }
          r.push(temp);
        }
      }
      let moment = this.$moment;
      this.$refs._dynTable.exportTable(
        [...r],
        `${name}-${moment()
          .locale('zh-cn')
          .format('YYYY-MM-DD HH:mm:ss')}`
      );
    }
  }
};
</script>
